// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-269fdf85] .search-by-select {\n  /* keep search by select from changing sizes when options change\n  due to books/gm/both selection */\n  min-width: 135px;\n}\n[data-v-269fdf85] .text-center input {\n  text-align: center;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
